import { render } from "./Index.vue?vue&type=template&id=22793351"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=22793351&lang=css"
script.render = render

export default script